import { lazy, Suspense } from 'react';

const LazyDriverRegisterHome = lazy(() => import('./DriverRegisterHome'));

const DriverRegisterHome = () => (
  <Suspense fallback={null}>
    <LazyDriverRegisterHome />
  </Suspense>
);

export default DriverRegisterHome;
